import React from "react";
import RichInputControls, {
  TRichInputControlsItem,
} from "@atlas/uicorn/lib/Control/RichInputControls";
import styled from "styled-components";
import UiRichInput, {
  SRichInput,
  SRichInputEditable,
  TRichInputProps,
} from "@atlas/uicorn/lib/Input/RichInput";

const FormRichInput = function FormRichInput(
  props: Pick<TRichInputProps, "defaultValue" | "onChange">
) {
  return (
    <UiRichInput {...props} placeholder="Add your message...">
      {(children) => (
        <SInputContainer>
          <SRichInputControls items={controlItems} />
          {children}
        </SInputContainer>
      )}
    </UiRichInput>
  );
};

export default FormRichInput;

export const controlItems: TRichInputControlsItem[] = [
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "code",

  "block-quote",
  "heading-one",
  "heading-two",
  "numbered-list",
  "bulleted-list",
];

const SRichInputControls = styled(RichInputControls)`
  padding: var(--padding);
  border-bottom: 0.1rem solid var(--border-color);
  width: 100%;
`;

const SInputContainer = styled.div`
  --padding: 0.8rem;
  --border-color: ${(p) => p.theme.color.grey6};

  background: ${(p) => p.theme.color.grey5};
  border: 0.1rem solid var(--border-color);
  border-radius: 0.8rem;

  ${SRichInput} {
    padding: var(--padding);
  }

  ${SRichInputEditable} {
    min-height: 10rem !important;
  }
`;
